export enum WalletType {
  WEB3 = 'WEB3',
  HARDWARE = 'HARDWARE',
  FILE = 'FILE',
  MISC = 'MISC'
}
